module.exports = __webpack_public_path__ + "img/bg_intro_1_4.a698bc41.svg";